import { useState } from 'react';
import { format } from 'date-fns';
import * as service from '../services';
import { useSetupAderenciaDePrecosStore } from '../SetupAderenciaDePrecos.store';
import { UploadState } from '../../SetupInfoPanelAnaliseDeCobertura/@types';
import * as utils from '../utils';

export const useUploadAderenciaFiles = () => {
  const [uploadProgress, setUploadProgress] = useState(0);
  const { setSetupAnaliseDeAderenciaState, setAderenciaUploadTableData } = useSetupAderenciaDePrecosStore();

  const controller = new AbortController();

  const simulateUpload = () => {
    setUploadProgress(0);

    const duration = 1250;
    const interval = 100;
    const steps = duration / interval;
    let currentProgress = 0;

    const timer = setInterval(() => {
      currentProgress += 100 / steps;

      if (currentProgress >= 100) {
        clearInterval(timer);
        setUploadProgress(99);
      } else {
        setUploadProgress(Math.min(currentProgress, 99));
      }
    }, interval);
  };

  const validateUploadProductFile = async (file: File) => {
    simulateUpload();
    setSetupAnaliseDeAderenciaState('uploadState', UploadState.UPLOADING);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const resp = await service.draftUploadAderencia(formData, controller);
      const data = resp.data;

      setSetupAnaliseDeAderenciaState('aderenciaProductUploadResponse', data);

      utils.setModalUploadStatus(resp, setSetupAnaliseDeAderenciaState);

      if (resp.status === 200) {
        setAderenciaUploadTableData(resp);
      }
    } catch (error) {
      const errorMessage = error.response.data[0]?.mensagem.replace('IllegalArgumentException: ', '');
      setSetupAnaliseDeAderenciaState('uploadState', UploadState.WRONG_FILE);
      setSetupAnaliseDeAderenciaState('uploadFileErrorMessage', errorMessage);
    }
  };

  const cancelUploadProductFile = () => {
    controller.abort();
  };

  return {
    uploadProgress,
    cancelUploadProductFile,
    validateUploadProductFile,
  };
};
